
import React from "react";
import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";
function ToastDefault() {

    return (
        <Toaster
            position="top-center"
            // containerStyle={{
            //     marginTop:'50px'
            // }}
            // position="bottom-center"
            containerStyle={{
                top: "35px",
                zIndex: 9999999
            }}
            reverseOrder={true}
        />


        // <ToastContainer
        //     autoClose={3000}
        //     hideProgressBar={true}
        //     className="toast-chilling"
        //     position="top-center"
        //     newestOnTop={false}
        //     closeOnClick={true}
        //     rtl={false}
        //     pauseOnFocusLoss={false}
        //     draggable={false}
        //     pauseOnHover={false}
        // />


    );
}

export default ToastDefault; 